export default __webpack_public_path__ + "static/media/google-analytics.cc7aab26.svg";